import React from 'react'
import Hero from './hero'
import SoffTypes from './soff-types'
import TwoCard from './two-card'
import InfoSection from './steps'
import SoffStats from './soff-stats'
import BestSellers from './best-sellers'
import Bests from './bests'
import Faqs from './faqs'
import HomeNavbar from './home-navbar'
import Footer from '../footer'
import TelegramWidget from './telegram-widget'

const HomePage = () => {
    return (
        <div>
            <HomeNavbar />
            {/* Hero section - uses global background variables */}
            <div style={{ background: 'var(--bg-primary)' }}>
                <div style={{ maxWidth: '1400px' }} className="container">
                    <Hero />
                </div>
            </div>
            {/* Dark band section for types */}
            <div style={{ background: 'var(--bg-header)' }}>
                <div style={{ maxWidth: '1400px' }} className="container">
                    <SoffTypes />
                </div>
            </div>
            {/* Light/content section driven by theme variables */}
            <div style={{ background: 'var(--bg-secondary-light)' }}>
                <div style={{ maxWidth: '1400px' }} className="container">
                    <TwoCard />
                    <InfoSection />
                    <SoffStats />
                    <BestSellers />
                    <Bests />
                    <Faqs />
                </div>
            </div>
            <Footer />
            <TelegramWidget />
        </div>
    )
}

export default HomePage